import React from "react";
import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";

const BADGES = [
  { img: "/xero-silver-block.webp", label: "Xero Silver Partner", testid: "badge-xero" },
  { img: "/qb-proadvisor-gold.png", label: "QuickBooks Gold ProAdvisor", testid: "badge-quickbooks" },
];

export const Accreditations = () => (
  <section data-testid="accreditations-section" className="py-16 sm:py-20 bg-[#F5F2EB] border-y border-[#103080]/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col md:flex-row items-center md:items-center justify-between gap-10">
      <div className="max-w-md text-center md:text-left">
        <p className="text-xs uppercase tracking-[0.3em] text-[#0090D0] font-medium mb-4">Certified experts</p>
        <h2 className="font-serif font-semibold tracking-tight text-[#103080] text-3xl sm:text-4xl leading-tight mb-4">
          Qualified in the software you already use.
        </h2>
        <p className="text-sm sm:text-base text-[#0F172A]/65 leading-relaxed">
          We're certified Xero and QuickBooks specialists — so your move to the cloud
          is guided by people who do it every day.
        </p>
      </div>
      <div className="flex items-center gap-10 sm:gap-14">
        {BADGES.map((b, i) => (
          <motion.figure
            key={b.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col items-center gap-3"
          >
            <img
              src={b.img}
              alt={b.label}
              data-testid={b.testid}
              className="h-20 sm:h-24 w-auto object-contain"
            />
            <figcaption className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-medium text-[#103080]">
              <BadgeCheck size={14} className="text-[#0090D0]" /> {b.label}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
